import React from 'react';
import styles from './adminBar.scss';

const AdminBar = (props) => {
    const { adminSplash, children } = props;

    return (
        <div
            className={`${styles.adminBar} ${adminSplash ? 'admin-splash bg-teal' : 'bg-transparent'}`}
        >
            <div className={`container bg-transparent`}>
                <div className="row">
                    <div className={`col d-flex align-items-center ${adminSplash ? 'justify-content-center' : 'justify-content-between'} flex-wrap-mobile`}>
                        {children}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AdminBar;
